import { restaurantsUrl } from "../resources";
import common from '../common/common.js';

async function getRestaurantById(restaurantId) {
    let url = `${restaurantsUrl}/${restaurantId}`;
    let data;
    await common.getDataWithToken(url)
                .then(res => {
                    data = res
                });
    return data;
}

export default {
    getRestaurantById
}